import { api } from "@/lib/api";

// Statistiques de fréquentation anonymes :
// - visitor_id : UUID aléatoire persistant (localStorage) — identifie un visiteur unique sans donnée personnelle
// - session_id : UUID par onglet/session (sessionStorage) — un rechargement de page ne recompte pas la visite
// - une page vue par page et par session maximum
// - les espaces /admin et /pro ne sont jamais comptabilisés

const VID_KEY = "gospot_vid";
const SID_KEY = "gospot_sid";
const EXCLUDED_PREFIXES = ["/admin", "/pro"];

const uuid = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const trackPageView = (path) => {
  try {
    if (!path || EXCLUDED_PREFIXES.some((p) => path.startsWith(p))) return;
    let vid = localStorage.getItem(VID_KEY);
    if (!vid) {
      vid = uuid();
      localStorage.setItem(VID_KEY, vid);
    }
    let sid = sessionStorage.getItem(SID_KEY);
    if (!sid) {
      sid = uuid();
      sessionStorage.setItem(SID_KEY, sid);
    }
    const dedupKey = `gospot_pv_${path}`;
    if (sessionStorage.getItem(dedupKey)) return;
    sessionStorage.setItem(dedupKey, "1");
    api.post("/analytics/visit", { visitor_id: vid, session_id: sid, path }).catch(() => {});
  } catch {
    // stockage indisponible (navigation privée stricte) : on ignore silencieusement
  }
};
